module.exports = __webpack_public_path__ + "img/type1.a36135c7.png";